/**
 * Reusable Error Display Component
 * Dark mode geek aesthetic
 */

interface ErrorDisplayProps {
  error: string | null
}

export default function ErrorDisplay({ error }: ErrorDisplayProps) {
  if (!error) return null

  return (
    <div className="bg-red-900/30 border border-red-500/50 rounded-lg p-4">
      <p className="text-red-300 font-mono text-sm">
        <span className="text-red-500">{'[ERROR]'}</span> {error}
      </p>
    </div>
  )
}
